import { render, staticRenderFns } from "./contracted.vue?vue&type=template&id=5c12f5f9&scoped=true"
import script from "./contracted.vue?vue&type=script&lang=js"
export * from "./contracted.vue?vue&type=script&lang=js"
import style0 from "./contracted.vue?vue&type=style&index=0&id=5c12f5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12f5f9",
  null
  
)

export default component.exports